// Sem patria globalne konstanty

export const SYSTEM_NAME_AUTH = 'AUTH';
export const SYSTEM_NAME_EPC = 'EPC';
export const SYSTEM_NAME_ETD = 'ETD';
export const SYSTEM_NAME_ISBN = 'ISBN';
export const SYSTEM_NAME_ROOMBOOK = 'ROOMBOOK';
export const SYSTEM_NAME_ZP = 'ZP';
export const SYSTEM_NAME_UIK = 'UIK';
export const SYSTEM_NAME_HELPDESK = 'HELPDESK';
export const SYSTEM_NAME_TOOLS = 'TOOLS';
export const SYSTEM_NAME_LIBADMIN = 'LIBADMIN';
export const SYSTEM_NAME_ALFRED = 'ALFRED';
export const SYSTEM_NAME_HELIOS = 'HELIOS';

export const AUTH_RETURN_URL_COOKIE_EXPIRATION = 1800000;
export const AUTH_TOKEN_REFRESH_INTERVAL = 1200000;
export const AUTH_TOKEN_EXPIRATION_THRESHOLD = 300000;
export const AUTH_TOKEN_EXPIRATION_CHECK_THRESHOLD = 1500000;
export const AUTH_REFRESH_TOKEN_EXPIRATION_THRESHOLD = 300000;

/*
  * USER ROLES
  *
  *
  *
*/
export const USER_ROLES = {
    SUPERADMIN: 'SUPERADMIN',
    UK_ADMIN: 'UK_ADMIN',
    ISBN_UK_ADMIN: 'ISBN_UK_ADMIN',
    ISBN_USER: 'ISBN_USER',
    STUDENT: 'STUDENT',
    PHD: 'PHD',
    EMPLOYEE: 'EMPLOYEE',
    PEDAGOGUE: 'PEDAGOGUE'
};

export const UserRoles = {
    All: [
        USER_ROLES.SUPERADMIN,
        USER_ROLES.ISBN_UK_ADMIN,
        USER_ROLES.ISBN_USER,
        USER_ROLES.UK_ADMIN,
        USER_ROLES.STUDENT,
        USER_ROLES.PHD,
        USER_ROLES.EMPLOYEE,
        USER_ROLES.PEDAGOGUE
    ],
    UkAdmin: USER_ROLES.UK_ADMIN,
    Superadmin: USER_ROLES.SUPERADMIN,
    IsbnUkAdmin: USER_ROLES.ISBN_UK_ADMIN,
    IsbnUser: USER_ROLES.ISBN_USER,
    Student: USER_ROLES.STUDENT,
    Phd: USER_ROLES.PHD,
    Employee: USER_ROLES.EMPLOYEE,
    Pedagogue: USER_ROLES.PEDAGOGUE
};

export enum EditionTypeCodeEnum {
    first = 'Prvé',
    second = 'Druhé',
    secondUpdated = 'Druhé aktualizované',
    secondAppended = 'Druhé doplnené',
    secondRework = 'Druhé prepracované',
    other = 'Iné'
}

export const EditionTypeCodes = [
    {
        value: EditionTypeCodeEnum.first
    },
    {
        value: EditionTypeCodeEnum.second
    },
    {
        value: EditionTypeCodeEnum.secondUpdated
    },
    {
        value: EditionTypeCodeEnum.secondAppended
    },
    {
        value: EditionTypeCodeEnum.secondRework
    },
    {
        value: EditionTypeCodeEnum.other
    }
]

export enum ErrorCodesEnum {
    GENERAL_ERROR = 1,
    NO_UNUSED_ISBN = 2001,
    ISBN_NOT_FOUND = 2002,
    NOT_VALID_ISBN = 2003,
    DUPLICATE_ISBN = 2004,
}

export const ErrorCodes = [
    {
        code: ErrorCodesEnum.NO_UNUSED_ISBN,
        text: 'NO_UNUSED_ISBN'
    },
    {
        code: ErrorCodesEnum.ISBN_NOT_FOUND,
        text: 'ISBN_NOT_FOUND'
    },
    {
        code: ErrorCodesEnum.NOT_VALID_ISBN,
        text: 'NOT_VALID_ISBN'
    },
    {
        code: ErrorCodesEnum.DUPLICATE_ISBN,
        text: 'DUPLICATE_ISBN'
    },
    {
        code: ErrorCodesEnum.GENERAL_ERROR,
        text: 'GENERAL_ERROR'
    }

]

export function getErrorByCode(code: ErrorCodesEnum) {
    const item = ErrorCodes.find(i => i.code === code);
    return item ? item.text : null;
}



// WEBPACK FOOTER //
// ./src/app/+app-custom/constants.ts